import { Text, ThemeProvider, TokenTextAppearance, styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import parse from 'html-react-parser';

export interface DisclaimerLayerContentProps {
  readonly closeButton: React.ReactNode;
  readonly text: string;
  readonly reference: string;
}

const closeButtonHeight = '44px';

const StyledCloseButtonWrapper = styled.div`
  position: sticky;
  top: ${(props) => props.theme.size.static100};
  right: ${(props) => props.theme.size.static100};
  margin-top: ${(props) => props.theme.size.static100};
  margin-right: ${(props) => props.theme.size.static100};
  margin-bottom: ${(props) => `calc(-1 * (${props.theme.size.static100} + ${closeButtonHeight}))`};
  text-align: right;

  button:focus {
    background-color: transparent;
    box-shadow: none;
    border-color: transparent;
  }
`;

const StyledDisclaimerWrapper = styled.div`
  padding-top: ${(props) => props.theme.size.static250};
  padding-right: 52px;
  padding-bottom: ${(props) => props.theme.size.static250};
  padding-left: ${(props) => props.theme.size.static250};
`;

const StyledDl = styled.dl`
  display: grid;
  grid-template-columns: ${(props) => props.theme.size.dynamic0100} auto;
  grid-column-gap: ${(props) => props.theme.size.static150};
  grid-row-gap: ${(props) => props.theme.size.static200};
  margin: 0;
  padding: 0;
`;

const StyledDd = styled.dd`
  margin: 0;
  padding: 0;
`;

const StyledDt = styled.dt`
  margin: 0;
  padding: 0;
`;

export function DisclaimerLayerContent({ closeButton, reference, text }: DisclaimerLayerContentProps): JSX.Element {
  return (
    <ThemeProvider theme="main">
      <ThemeProvider theme="inverted">
        <StyledCloseButtonWrapper>{closeButton}</StyledCloseButtonWrapper>
        <StyledDisclaimerWrapper>
          <Text appearance={TokenTextAppearance.copy200} wordBreak staticSize>
            <StyledDl>
              <StyledDt>{reference}</StyledDt>
              <StyledDd />
              {parse(text)}
            </StyledDl>
          </Text>
        </StyledDisclaimerWrapper>
      </ThemeProvider>
    </ThemeProvider>
  );
}
